import Icon from '../components/Icon.vue'

Icon.register({
  tasks: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M139.6 35.5l17 16.5c1.9 1.9 3.4 5.7 3.4 8.5 0 2.8-1.6 6.6-3.5 8.5l-72.2 72.2-15.6 15.6c-2 1.9-6 3.5-8.8 3.5-2.8 0-6.8-1.6-8.8-3.5l-47.6-47.4c-1.9-1.9-3.5-5.8-3.5-8.5 0-2.8 1.6-6.6 3.5-8.5l15.7-15.7c1.9-1.9 5.7-3.5 8.5-3.5 2.8 0 6.6 1.6 8.5 3.5l22.7 22.1 63.7-63.3c1.9-1.9 5.7-3.5 8.5-3.5 2.8 0 6.6 1.6 8.5 3.5zM139.6 194.7l17 17c1.9 1.9 3.4 5.7 3.4 8.4 0 2.7-1.6 6.6-3.5 8.5l-72.2 72.2-15.7 15.7c-2 1.9-6 3.5-8.8 3.5s-6.8-1.6-8.8-3.5l-47.5-47.5c-1.9-1.9-3.5-5.7-3.5-8.5s1.6-6.6 3.5-8.5l15.7-15.7c1.9-1.9 5.7-3.5 8.5-3.5 2.8 0 6.6 1.6 8.5 3.5l22.7 22.1 63.7-63.7c1.9-1.9 5.7-3.5 8.5-3.5 2.8 0 6.6 1.6 8.5 3.5zM64 368c26.5 0 48 21.5 48 48s-21.5 48-48 48c-26.5 0-48.6-21.5-48.6-48s22.1-48 48.6-48zM496 384c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-288c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h288zM496 64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-288c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h288zM496 224c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-288c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h288z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/tasks.js
// module id = 1984
// module chunks = 0